module.exports = __webpack_public_path__ + "img/cns_printer_mac8_5.49de85d0.png";